import React from 'react';
import PropTypes from 'prop-types';

import { FilterContextProvider } from 'contexts/filter-context';
import mainContentDefaultOptions from 'js/block-area/main-content-default-options';

import Columns from 'components/columns';
import ContentWrapper from 'components/content-wrapper';
import ComponentList from 'components/component-list';
import Filters from 'components/filters';
import Heading from 'components/heading';
import Layout from 'components/layout';
import PromoBlock from 'components/promo-block';
import Text from 'components/text';
import PageList from 'components/page-list';
import Pagination from 'components/pagination';

const PageListPage = ({
  filters,
  ingress,
  layout,
  promotedPage,
  title,
  pageList,
  pagination,
  blocks
}) => {
  return (
    <Layout {...layout}>
      <FilterContextProvider>
        <Columns>
          <Columns.Main>
            <div className="page-list-page__header">
              <Heading level={1} theme={Heading.themes.h1}>
                {title}
              </Heading>
              <Text theme={Text.themes.ingress}>{ingress}</Text>
            </div>
          </Columns.Main>
        </Columns>

        {promotedPage && (
          <div className="page-list-page__promoted">
            <PromoBlock {...promotedPage} align={PromoBlock.alignments.left} />
          </div>
        )}
        {filters && (
          <ContentWrapper className="page-list-page__filters">
            <Filters {...filters} />
          </ContentWrapper>
        )}
        <ContentWrapper className="page-list-page__page-list">
          <PageList {...pageList}></PageList>
          {pagination && <Pagination {...pagination}></Pagination>}
        </ContentWrapper>
      </FilterContextProvider>
      {blocks && (
        <ContentWrapper>
          <ComponentList {...blocks} {...mainContentDefaultOptions} />
        </ContentWrapper>
      )}
    </Layout>
  );
};

PageListPage.propTypes = {
  blocks: PropTypes.exact(ComponentList.propTypes),
  filters: PropTypes.exact(Filters.propTypes),
  ingress: PropTypes.string,
  layout: PropTypes.exact(Layout.propTypes),
  pageList: PropTypes.exact(PageList.propTypes),
  promotedPage: PropTypes.exact(PromoBlock.propTypes),
  title: PropTypes.string.isRequired,
  pagination: PropTypes.exact(Pagination.propTypes)
};

export default PageListPage;
